import { HStack, Text } from "@chakra-ui/react";
import {
  Pagination,
  PaginationContainer,
  PaginationNext,
  PaginationPage,
  PaginationPageGroup,
  PaginationPrevious,
  PaginationSeparator,
  usePagination,
} from "@ajna/pagination";

import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

import clamp from "lodash/clamp";

// interface PaginatorProps {
//   totalCount: number;
//   limit: number;
//   page: number;

//   onNextPage: (nextPage: number) => void;
// }

export default function Paginator(props /*: PaginatorProps*/) {
  const { totalCount, limit, page, onNextPage, ...xprops } = props;
  const {
    pages,
    pagesCount,
    offset,
    currentPage,
    setCurrentPage,
    isDisabled,
    pageSize,
  } = usePagination({
    total: totalCount,
    limits: {
      outer: 1,
      inner: 1,
    },
    initialState: {
      pageSize: limit,
      isDisabled: false,
      currentPage: page,
    },
  });

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
    onNextPage && onNextPage(nextPage);
  };

  return (
    <HStack
      // bg="white"
      p="20px 0"
      justifyContent="space-between"
      // borderRadius="0px 0px 16px 16px"
      flexDir={["column", "row"]}
      w="100%"
      // mt="0 !important"
      {...xprops}
    >
      {totalCount > 0 && (
        <Text>
          Showing {offset + 1} to{" "}
          {clamp(offset + pageSize, pageSize, totalCount ?? 0)} of{" "}
          {totalCount ?? 0}
        </Text>
      )}
      <HStack>
        <Pagination
          pagesCount={pagesCount}
          currentPage={currentPage}
          isDisabled={isDisabled}
          onPageChange={handlePageChange}
        >
          <PaginationContainer
            align="center"
            justify="space-between"
            p={4}
            w="full"
          >
            <PaginationPrevious
              mr="8px"
              boxSize="32px"
              _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
              _active={{ bg: "transparent" }}
              _hover={{
                bg: "transparent",
              }}
              bg="transparent"
            >
              <ChevronLeftIcon />
            </PaginationPrevious>
            <PaginationPageGroup
              isInline
              align="center"
              minH="32px"
              minW="32px"
              separator={
                <PaginationSeparator
                  border="1px solid #DFE3E8"
                  bg="transparent"
                  fontSize="sm"
                  boxSize="32px"
                  jumpSize={4}
                  _active={{ bg: "transparent" }}
                  _hover={{
                    bg: "transparent",
                  }}
                  _focus={{
                    borderColor: "transparent",
                    shadow: "0 0 0 3px var(--focusColor)",
                  }}
                />
              }
            >
              {pages.map((page) => (
                <PaginationPage
                  boxSize="32px"
                  bg="transparent"
                  border="1px solid #DFE3E8"
                  key={`pagination_page_${
                    page || Math.random() * 7676767665453
                  }`}
                  page={page}
                  fontSize="sm"
                  _active={{ bg: "transparent" }}
                  _hover={{
                    bg: "transparent",
                  }}
                  _focus={{
                    borderColor: "transparent",
                    shadow: "0 0 0 3px var(--focusColor)",
                  }}
                  _current={{
                    borderColor: "transparent",
                    bg: "#03a438",
                    fontSize: "sm",
                    boxSize: "32px",
                    color: "white",
                    _hover: {
                      borderColor: "#DFE3E8",
                      bg: "transparent",
                      color: "black",
                    },
                  }}
                />
              ))}
            </PaginationPageGroup>

            <PaginationNext
              ml="8px"
              boxSize="32px"
              _active={{ bg: "transparent" }}
              _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
              _hover={{
                bg: "transparent",
              }}
              bg="transparent"
            >
              <ChevronRightIcon />
            </PaginationNext>
          </PaginationContainer>
        </Pagination>
      </HStack>
    </HStack>
  );
}
